import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _, { unset } from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import Select from 'react-select';
import { customStyle } from 'helper';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function CreateFloorAreaModal({
  updateData,
  getList, 
  id,
  floorData,
  // createInputNumber,
  getActualUseList,
  actualUseList
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState([]);
  const [floorNumber, setFloorNumber] = useState(0);

  // const [landClass, setLandClass] = useState({
  //   label: '',
  //   value: 0,
  // });

  useEffect(() => {
    getActualUseList();

    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const handleOnSubmit = (e) => {
    _.forEach(formData, (d) => {
      unset(d, ['id'])
    });

    e.preventDefault();
    const args = {
      floor_storey_areas: formData,
    };
    updateData(id, args, () => {
      setModal({ isOpen: false });
      getList(id);
    });
  };

  const handleOnChangeRow = (key, index) => (e) => {
    setFormData(formData.map((item) => {
      if (+item.id === +index) {
        return {
          ...item,
          [key]: e.target.value,
        };
      }
      return item;
    }));
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnChange = (e) => {
    setFloorNumber(0);
    setFloorNumber(e.target.value);
  };

  const handleAddFloor = () => {
    const array = [];
    if (_.isEmpty(floorData)) {
      for (let i = 0; i < floorNumber; i += 1) {
        array.push({
          id: i,
          floor: i + 1,
          area: '',
          rptax_actual_use_id: '',
        });
      }
    }
    if (!_.isEmpty(floorData)) {
      const lastId = floorData.length + 1;
      const total = +lastId + +floorNumber;
      for (let i = lastId; i < total; i += 1) {
        array.push({
          id: i,
          floor: i,
          area: '',
          rptax_actual_use_id: '',
        });
      }
    }
    setFormData(array);
  };
  const handleLandClassSelect = (key, index) => (e) => {
    setFormData(formData.map((item) => {
      if (+item.id === +index) {
        return {
          ...item,
          [key]: e.rptax_actual_use_id,
        };
      }
      return item;
    }));
  };

  const createDropdownLandClass = list => {
    const newList = [];
    list.map(data => {
      return newList.push({
        label: data.attributes.name,
        rptax_actual_use_id: data.id,
      });
    });
    return newList;
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <div className="d-flex">
              <label htmlFor="enter_#_of_floors" className="full-label mb-0 mr-3 text-color font-weight-bold">
                Enter # of Floors:
              </label>
              <input
                className="full-input"
                type="number"
                id="floorNumber"
                name="floorNumber"
                autoComplete="none"
                min="1"
                onChange={handleOnChange}
                value={floorNumber || ''}
              />
              <button
                type="button"
                onClick={handleAddFloor}
                className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto"
              >
                <i className="fas fa-plus" /> Add Floor
              </button>
            </div>
          </div>
          {formData.map((el, i) => (
            <div className="col-12" key={el.id}>
              {(_.isEmpty(floorData))
                ? (
                  <>
                    <div className="row">
                      <div className="col-6 form-group">
                        <label className="form-label d-flex align-items-center">
                          <span className="text-color-title font-weight-bold"> Floor No. {i + 1} Area: </span>
                        </label>
                        <input
                          className="form-control"
                          type="number"
                          id="area"
                          name="area"
                          autoComplete="none"
                          onChange={handleOnChangeRow('area', i)}
                          value={_.get(el, 'area') || ''}
                        />
                      </div>
                      <div className="col-6 form-group">
                        <label className="text-color-title font-weight-bold">Actual Use</label>
                        <div>
                          <Select
                            options={createDropdownLandClass(actualUseList)}
                            styles={customStyle}
                            placeholder="Select Actual Use"
                            value={createDropdownLandClass(actualUseList).filter(item => _.get(el, 'rptax_actual_use_id') === _.get(item, 'rptax_actual_use_id')) || ''}
                            onChange={handleLandClassSelect('rptax_actual_use_id', i)}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <span className="mr-1"> <u> Floor No. {el.id}: </u> </span>
                    <div className="col-2">
                      <input
                        className="full-input"
                        type="number"
                        id="area"
                        name="area"
                        autoComplete="none"
                        onChange={handleOnChangeRow('area', el.id)}
                        value={_.get(el, 'area') || ''}
                      />
                    </div>
                  </>
                )
              }
            </div>
          ))}
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              Submit
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">
              Cancel
            </span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateFloorAreaModal.defaultProps = {
  id: '',
};

CreateFloorAreaModal.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  updateData: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string,
  floorData: PropTypes.instanceOf(Object).isRequired,
  getActualUseList: PropTypes.instanceOf(Function).isRequired,
  actualUseList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  actualUseList: _.get(api, `${c.GET_ACTUAL_USE_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(
    mapStateToProps,
    {
      ...actions,
    },
  ),
]);

export default enhance(CreateFloorAreaModal);
